// COMPONENTS
import Text from '../../../../../core-components/TextFieldExpt/TextFieldExpt';
import AutoSuggestPopularLocation from './AutoSuggestPopularLocation';

// UTILS
import {getPropertyCount} from '@stencil/hotels-utils/src/autoSuggest-utils/common-utils';

// ICONS
import AutosuggestIconSelector from '../../../../../../shared/components/AutosuggestIconSelector';
import TripAdvisorIcon from '../../../../../../stories/Icons/TripAdvisorIcon';

// STYLES
import * as S from '../HomePageAutosuggest/HomePageAutosuggest.styles';
import {
  BaseColumnWrap,
  FlexItem,
  CenteredSpaceWrap,
} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

interface AutosuggestDropdownNewProps {
  items: any;
  isOpen: any;
  getMenuProps: any;
  getItemProps: any;
  highlightedIndex: any;
  selectedItem: any;
  menuStyle: any;
  inputValue: any;
  showPopularDestinations: any;
}

const AutosuggestDropdownNew: React.FC<AutosuggestDropdownNewProps> = props => {
  const {
    items,
    isOpen,
    getMenuProps,
    getItemProps,
    highlightedIndex,
    selectedItem,
    menuStyle,
    inputValue,
    showPopularDestinations = false,
  } = props;
  var counterIndex = -1;

  const getName = item => {
    if (
      (item?.type?.toLowerCase() === 'area' || item?.type?.toLowerCase() === 'poi') &&
      item?.countryCode?.toLowerCase() !== 'IN' &&
      item?.countryName
    ) {
      return `${item?.displayName || item?.name}, ${item.countryName}`;
    }
    return item?.displayName;
  };

  return (
    <S.SearchMenuStyles
      {...getMenuProps()}
      {...menuStyle}
      data-testid="autosuggest-suggestions-container"
      // @ts-ignore
    >
      {items?.length > 0 &&
        isOpen &&
        items.map((item, index) => {
          const idKeyComponent = item.voyId || '';
          const nameKeyComponent = item.name || '';
          const key = `${idKeyComponent}-${nameKeyComponent}-${index}`;

          const hasClickableProp = item?.hasOwnProperty('isClickable');
          let itemProps;
          const {isClickable = true} = item;
          if (hasClickableProp) {
            if (isClickable) {
              ++counterIndex;
              itemProps = getItemProps({
                item,
                index: counterIndex,
                $isActive: highlightedIndex === counterIndex,
                isSelected: selectedItem === item,
              });
            }
          } else {
            ++counterIndex;
            itemProps = getItemProps({
              item,
              index: counterIndex,
              isActive: highlightedIndex === counterIndex,
              isSelected: selectedItem === item,
            });
          }
          const propertyCount = getPropertyCount(item);

          if (item?.isChild) return;
          if (item?.group?.length) {
            return (
              <S.AutoSuggestItem
                // @ts-ignore
                {...itemProps}
                key={key}
              >
                <BaseColumnWrap>
                  <S.AutosuggestLocationDiv>
                    <FlexItem>
                      <S.NearByLocationImg src=" https://gos3.ibcdn.com/locationnearby-1610123817.svg" />
                      <S.SuggestionWrapperDiv>
                        <S.LoctionName className={isClickable ? '' : 'disabled'}>
                          {item?.displayName || item?.name}
                        </S.LoctionName>
                        {(propertyCount && isClickable && (
                          <FlexItem>
                            <S.NumberofPropertySpan>
                              View all {propertyCount} properties
                            </S.NumberofPropertySpan>
                          </FlexItem>
                        )) ||
                          null}
                      </S.SuggestionWrapperDiv>
                    </FlexItem>
                    <S.AutoSuggestRightWrap>
                      <S.LocationTypeWrapper className={isClickable ? '' : 'disabled'}>
                        {item?.htype}
                      </S.LocationTypeWrapper>
                    </S.AutoSuggestRightWrap>
                  </S.AutosuggestLocationDiv>
                  {item?.group && (
                    <S.AutoSuggestLocationNewItems>
                      {item.group.map((child, i) => {
                        const idChildKeyComponent = child.voyId || '';
                        const childNameKeyComponent = child.name || '';
                        const childKey = `${idChildKeyComponent}-${childNameKeyComponent}-${i}`;
                        ++counterIndex;
                        // const childIndex = Number(`${index}.${i+1}`);
                        const childPropertyCount = getPropertyCount(child);
                        return (
                          <S.AutoSuggestChildItem
                            // @ts-ignore
                            {...getItemProps({
                              item: child,
                              index: counterIndex,
                              isActive: highlightedIndex === counterIndex,
                              isSelected: selectedItem === child,
                              childIndex: i + 1,
                            })}
                            key={childKey}
                          >
                            <S.AutoSuggestChildItemInner>
                              <S.LineDiv />
                              <S.PropertyNameOuterWrapper>
                                <CenteredSpaceWrap>
                                  <S.CityNameDiv>{child?.name} </S.CityNameDiv>
                                  <S.LocationTypeWrapper>{child?.htype}</S.LocationTypeWrapper>
                                </CenteredSpaceWrap>
                                <S.PropertyDetailsNameDiv>
                                  {childPropertyCount +
                                    (child.htlCount > 1 ? ' Properties' : ' Property')}
                                </S.PropertyDetailsNameDiv>
                              </S.PropertyNameOuterWrapper>
                            </S.AutoSuggestChildItemInner>
                          </S.AutoSuggestChildItem>
                        );
                      })}
                    </S.AutoSuggestLocationNewItems>
                  )}
                </BaseColumnWrap>
              </S.AutoSuggestItem>
            );
          }

          return (
            <S.SearchListItem
              // @ts-ignore
              {...itemProps}
              key={key} // fallback because voyager sends _id = null sometimes
            >
              <S.StyledIcon
              // @ts-ignore
              >
                <AutosuggestIconSelector width="2rem" height="2rem" name={item.type} />
              </S.StyledIcon>
              <S.SearchListItemLocationName>{getName(item)}</S.SearchListItemLocationName>
              <S.SearchListItemLocationType>
                <div>{item?.htype}</div>
                {item.g_rtg && (
                  <S.RatingStyles rating={item.g_rtg}>
                    {/* gri === 3 is triadvisor */}
                    {item.gri === 3 && (
                      // 🐨 use <Image /> component when its ready
                      <TripAdvisorIcon />
                    )}
                    <Text inline customFontSize="1.4">
                      {item.g_rtg} / 5
                    </Text>
                  </S.RatingStyles>
                )}
                {(propertyCount && (
                  <S.SearchHotelNumber>
                    {propertyCount + (propertyCount > 1 ? ' Properties' : ' Property')}
                  </S.SearchHotelNumber>
                )) ||
                  null}
              </S.SearchListItemLocationType>
            </S.SearchListItem>
          );
        })}

      {showPopularDestinations ? <AutoSuggestPopularLocation {...props} /> : null}
    </S.SearchMenuStyles>
  );
};

export default AutosuggestDropdownNew;
